module.exports = __webpack_public_path__ + "static/media/banner-voala-cupom-dia-dos-pais.d3b5b517.jpg";